import React from "react";
import { Outlet } from "react-router-dom";
import { Mail, Instagram, Linkedin } from "lucide-react";
import SiteNav from "./SiteNav";
import "./layout.css";

const Layout: React.FC = () => {
  return (
    <div className="layout-root">
      <SiteNav />
      <main className="layout-main">
        <div className="layout-main-inner">
          <Outlet />
        </div>
      </main>

      <footer className="layout-footer">
        <div className="layout-footer-inner">
          <div className="layout-footer-links">
            <a href="mailto:hello@tribelet.co.uk" target="_blank" rel="noreferrer">
              <Mail size={20} />
            </a>
            <a href="https://www.instagram.com/tribeletco" target="_blank" rel="noreferrer">
              <Instagram size={20} />
            </a>
            <a href="https://linkedin.com/company/tribelet" target="_blank" rel="noreferrer">
              <Linkedin size={20} />
            </a>
          </div>
          <p className="layout-footer-copy">© {new Date().getFullYear()} Tribelet · All Rights Reserved</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
